import {
  Input as ReactStrapInput,
  Nav as ReactStrapNav,
  Navbar as ReactStrapNavbar,
  Alert,
  Form,
  Button,
  FormGroup,
  NavbarBrand as ReactNavbarBrand,
} from "reactstrap";
import styled from "styled-components";
import heroImage from "../assets/img/hero_image.jpg";
import { isMobile } from "react-device-detect";

const Icon = styled.i`
  font-size: ${(props) => props.size};
`;

const Input = styled(ReactStrapInput)`
  padding: 8px 15px;
`;

const Nav = styled(ReactStrapNav)`
  gap: 40px;
`;

const Navbar = styled(ReactStrapNavbar)`
  position: sticky;
  top: ${(props) => props.top};
  z-index: 2;
  border-bottom: 2px solid lightgray;
  background-color: white;
`;

const SearchBar = styled.div`
  position: sticky;
  top: ${(props) => (props.carpenterview == "true" ? "5px" : "60px")};
  z-index: 1;
  background-color: white;
  margin-left: 12px;
  margin-right: 12px;
`;

const ProductName = styled(ReactNavbarBrand)`
  width: 60%;
  font-size: 16px;
  white-space: wrap;
  display: flex;
  align-items: center;
`;

const NavItemContainer = styled.div`
  gap: 10px;
  cursor: pointer;
`;

const Notification = styled(Alert)`
  position: fixed;
  top: 3px;
  left: 50%;
  min-width: 300px;
  width: fit-content;
  margin-left: -150px;
  z-index: 99999999;
  text-align: center;
`;

const CoreContainer = styled.div`
  height: ${(props) => props.height || "92vh"};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const FullViewContainer = styled.div`
  height: ${(props) => (isMobile ? "72vh" : props.height || "80vh")};
  overflow: ${(props) => props.overflow};
`;

const CustomizationSpinnerContainer = styled.div`
  z-index: 9999;
  position: absolute;
  top: ${(props) => props.top || "50px"};
  left: ${(props) => props.left || "50%"};
  display: flex;
  justify-content: center;
`;

const LandingPageContainer = styled.div`
  max-width: 1200px;
  margin: auto;
  .form-control.is-invalid:focus {
    box-shadow: none !important;
  }
`;

const HeroSectionContainer = styled.div`
  position: relative;
  background-image: url(${heroImage});
  background-position: center;
  background-size: cover;
`;

const HeroSection = styled.div`
  position: relative;
  z-index: 1;
  width: 900px;
  margin: auto;
  padding-top: 3.5rem;
  @media (max-width: 992px) {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  @media (max-width: 900px) {
    width: 100%;
  }
  @media (max-width: 576px) {
    padding: 2rem 1rem 0 1rem;
  }
`;

const Logo = styled.img`
  height: ${(props) => props.height};
  width: ${(props) => props.width};
  @media (max-width: 576px) {
    width: ${(props) => props.mobilewidth};
    height: ${(props) => props.mobileheight};
  }
`;

const HeadingContainer = styled.div`
  color: white;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.7);
  padding-top: 4.5rem;
  text-align: center;
  @media (max-width: 576px) {
    padding-top: 3rem;
  }
`;

const Heading = styled.h1`
  font-size: 40px;
  line-height: 1.4;
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const TextContainer = styled.div`
  color: white;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.7);
  text-align: center;
  padding-top: 3.2rem;
  @media (max-width: 576px) {
    padding-top: 2.5rem;
  }
`;

const Text = styled.h1`
  font-size: 1.6rem;
  line-height: 1.4;
  @media (max-width: 900px) {
    font-size: 1.4rem;
  }
  @media (max-width: 576px) {
    font-size: 1.2rem;
  }
`;

const SubText = styled.p`
  font-size: 1rem !important;
  margin: 0;
  margin-top: 1rem;
  @media (max-width: 576px) {
    display: none;
  }
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.66);
`;

const HeroBtnContainer = styled.div`
  padding-top: 5rem;
  padding-bottom: 2rem;
  @media (max-width: 576px) {
    padding-top: 3rem;
  }
`;

const HeroButton = styled(Button)`
  background-color: #b35085;
  border-radius: 4px;
  padding: 12px 40px;
  font-weight: bold;
  color: white;
  border: 0;
  font-size: 20px !important;
  @media (max-width: 576px) {
    font-size: 16px !important;
  }
  &:hover {
    background-color: #b0609a;
  }
  &:active,
  &:focus-visible {
    background-color: #b35085 !important;
  }
`;

const BenefitHead = styled.h5`
  font-size: 3rem;
  text-align: center;
  margin-top: 0.5rem;
  @media (max-width: 700px) {
    font-size: 2rem;
  }
`;

const BenefitProjectContainer = styled.div`
  display: flex;
  justify-content: space-around;
  margin-top: ${(props) => props.margintop};
  @media (max-width: 700px) {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
  @media (max-width: 350px) {
    padding: 0 20px;
  }
`;

const BenefitCard = styled.div`
  width: 310px;
  @media (max-width: 350px) {
    width: 100%;
  }
`;

const CardHead = styled.p`
  font-size: 20px !important;
  font-weight: bold;
  margin-bottom: 12px;
`;

const Video = styled.iframe`
  width: 640px;
  height: 360px;
  @media (max-width: 700px) {
    width: 100%;
  }
  @media (max-width: 530px) {
    height: 100%;
  }
`;

const FooterSection = styled.div`
  padding: 3rem 0 2.5rem 0;
  background-color: black;
  @media (max-width: 730px) {
    flex-direction: column;
    padding-bottom: 1.5rem;
  }
`;

const FooterFormSection = styled.div`
  display: flex;
  justify-content: end;
  @media (max-width: 730px) {
    width: 100%;
    justify-content: center;
  }
`;

const FooterFormContainer = styled.div`
  width: 390px;
  @media (max-width: 390px) {
    width: 100%;
  }
`;

const FormHeaderContainer = styled.div`
  background-color: white;
  width: 100%;
  height: 73px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const FormHeader = styled.p`
  margin: 0;
  font-size: 1.5rem !important;
  font-weight: 700;
`;

const LandingPageForm = styled(Form)`
  background-color: white;
  padding: 20px;
  margin-top: 2px;
`;

const LandingPageFormGroup = styled(FormGroup)`
  margin: 0 !important;
`;

const LandingPageInput = styled(ReactStrapInput)`
  border: 0;
  outline: none;
  border-radius: inherit;
  border-bottom: 1px solid #9e9e9e;
  padding: 0 5px;
  margin: 4px 0;
  height: 57px;
  color: #161616 !important;
  font-size: 16px !important;
  &:focus {
    box-shadow: none;
    border-color: #9e9e9e;
  }
`;

const FormButton = styled(Button)`
  border-radius: 4px;
  background-color: #661f5c;
  border: 0;
  padding: 10px 5px 10px 5px;
  margin: 4px 0px;
  font-size: 16px !important;
  font-weight: bold;
  color: white;
  height: 46px;
  width: 100%;
  &:hover {
    background-color: #661f5cd1;
  }
  &:active,
  &:focus-visible {
    background-color: #661f5c !important;
  }
`;

const FooterInfoSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: end;
  padding-left: 3rem;
  @media (max-width: 730px) {
    width: 100%;
    padding: 1.5rem 0 0 0;
    align-items: center;
  }
`;

const FooterInfo = styled.p`
  font-size: ${(props) => props.size}!important;
  color: ${(props) => props.color || "white"};
  margin-top: 5px;
  margin-bottom: 0px;
`;

const CLPImage = styled.img`
  max-width: 100%;
  height: 300px;
  @media (max-width: 500px) {
    width: fit-content;
    height: 180px;
  }
`;

const CLPLabel = styled.p`
  margin-bottom: 5px;
  color: gray;
  font-weight: bold;
  padding: 0;
`;

const CLPButton = styled(Button)`
  width: 100%;
  background: #b35085;
  &:hover {
    background-color: #b0609a;
  }
  &:active,
  &:focus-visible {
    background-color: #b35085 !important;
  }
`;

const InfoContainer = styled.div`
  padding-bottom: 85px;
  @media (max-width: 413px) {
    padding-bottom: 110px;
  }
`;

const CircledLabel = styled.span`
  font-size: 1em;
  width: 20px;
  height: 20px;
  background: #686868;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
`;

const DimensionInput = styled(ReactStrapInput)`
  max-width: 100px;
  margin-top: 8px;
  width: 60px;

  &.form-control.is-invalid {
    border-color: var(--bs-form-invalid-border-color);
    padding-right: 0.75rem;
    background-image: none;
  }
`;

const ExtensionInput = styled(ReactStrapInput)`
    max-width: 100px;
    margin-top: 8px;
    width: 50px;
    font-size: 11px !important;

    &.form-control.is-invalid {
        border-color: var(--bs-form-invalid-border-color);
        padding-right: 0.75rem;
        background-image: none;
    }

`;

const Header = styled.header.attrs({
  className:
    "d-flex justify-content-between position-fixed top-0 start-0 end-0",
})`
  height: 70px;
  z-index: 1000;
  background: #ddd;
  padding: 0 80px;
`;

const NavbarBrand = styled(ReactNavbarBrand).attrs({
  className: "d-flex justify-content-center",
})``;

const NavbarBrandImg = styled.img.attrs({
  className: "object-fit-contain logo",
})``;

const RegisterButton = styled(Button).attrs({
  className: "ms-5 text-uppercase rounded-pill bg-primary border-0",
})`
  padding: 10px 25px;
  &:hover {
    background: #fff !important;
    color: #1b8eed;
  }
`;

const HeroSectionVideo = styled.video.attrs({
  className: "vw-100 vh-100 object-fit-cover",
})`
  background-image: url("https://cdn.prod.website-files.com/65c9a7c623ab16435fce4b7e%2F665ef2efb1a9048375bdd91a_website%20video%201_1-poster-00001.jpg");
  position: absolute;
  top: 0;
  bottom: 0;
`;

const HeroSectionHeading1 = styled.h2.attrs({})`
  line-height: 100%;
  font-size: 4em;
  color: #ccc !important;
`;

const HeroSectionHeading2 = styled.h1.attrs({
  className: "text-white my-0",
})`
  text-shadow: 0 0 20px #000;
  font-size: 2em;
  line-height: 1em;
  margin-top: 24px !important;

  .modules {
    color: #1b8eed !important;
    font-style: italic;
  }
`;

const WhiteBtn = styled.a.attrs({
  className:
    "fs-6 text-black bg-white fw-semibold d-inline-block text-decoration-none pointer",
})`
  margin-top: 28px;
  border-radius: 10px;
  padding: 22px 22px 22px 21.34px;
  line-height: 90.5%;
  transition: background-color 1s, color 1s;
  &:hover {
    color: white !important;
    background-color: #1b8eed !important;
  }
`;

const Section = styled.section`
  padding-top: ${(props) => props.paddingtop};
  padding-bottom: ${(props) => props.paddingbottom};
  padding-left: ${(props) => props.paddingleft};
  column-gap: ${(props) => props.colgap};
  background-color: ${(props) => props.bgcolor};
  border-top: ${(props) => props.border == "true" && "5px solid #eee"};
`;

const BusinessEasySectionHeading1 = styled.span.attrs({
  className: "fw-bold",
})`
  color: #1d1d1f;
  font-size: 58px;
`;

const BusinessEasySectionHeading2 = styled.span.attrs({
  className: "d-block",
})`
  color: #1d1d1f;
  font-size: 48px;
  line-height: 60px;
`;

const Frame = styled.div.attrs({
  className: "d-flex",
})`
  row-gap: ${(props) => props.rowgap};
  column-gap: ${(props) => props.colgap};
`;

const FrameText = styled.span`
  color: ${(props) => props.color};
  font-size: ${(props) => props.size};
  font-weight: ${(props) => props.weight};
  line-height: ${(props) => props.lineheight};
  width: ${(props) => props.width};
`;

const AISectionImage = styled.img.attrs({
  className: "rounded-3",
})`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  filter: grayscale(0.5);
`;

const KnowMoreButton = styled.div.attrs({
  className: "bg-primary pointer",
})`
  border-radius: 49.0019px;
  padding: 18px 20px;
`;

const Tag = styled.div.attrs({
  className: "fw-semibold text-uppercase text-center",
})`
  font-size: 30px;
  color: #666;
`;

const TechBox = styled.div.attrs({
  className: "text-center w-25",
})`
  border: 1px solid #d9d9d9;
  border-radius: 10px;
  padding: 20px;
`;

const TableContainer = styled.div`
  border: 1px solid #e3e3e3;
  margin-top: 43px;
`;

const TableRow = styled.div.attrs({
  className: "d-grid",
})`
  grid-template-rows: auto;
  grid-template-columns: 50% 25% 25%;
  grid-auto-columns: 1fr;
  &:nth-child(odd) {
    background-color: #f9f9f9;
  }
`;

const Column = styled.div`
  padding: 20px 36px;
  width: ${(props) => props.width};
  background-color: ${(props) => props.bgcolor};
`;

const ReadMoreButton = styled.a.attrs({
  className: "d-inline-block fw-semibold text-decoration-none",
})`
  color: #0f0f0f;
  background-image: url(https://cdn.prod.website-files.com/65c9a7c623ab16435fce4b7e/65ca6097cad038b9a34e11da_next_arrow.svg);
  background-position: 86%;
  background-repeat: no-repeat;
  background-size: 25px;
  border: 1px solid #242121;
  border-radius: 46px;
  padding: 20px 70px 20px 20px;
  font-size: 17px;
  line-height: 16px;
`;

const FeatureImg = styled.img.attrs({
  className: "me-3 object-fit-cover",
})`
  width: 80px;
  height: 80px;
`;

const FaqToggleContainer = styled.div.attrs({
  className: "mt-4",
})`
  background: #eee;
  border: 1px solid #ccc;
`;

const FaqToggleRow = styled.div.attrs({
  className: "d-block overflow-hidden",
})`
  max-height: 80px;
  border-bottom: 1px solid #ccc;
  padding: 0 25px 28px;
  transition: background-color 500ms linear, max-height 500ms linear;
  &.active {
    max-height: 270px;
    background-color: rgb(29, 29, 31);
  }
`;

const FaqToggleHeader = styled.div.attrs({
  className: "position-relative d-flex align-items-center",
})`
  height: 80px;
  border-bottom: solid 1px rgba(255, 255, 255, 0.5);
`;

const PlusIcon = styled.div.attrs({
  className: "position-absolute end-0",
})`
  width: 18px;
`;

const FaqToggleBody = styled.div`
  margin-top: 20px;
  color: #969696;
  font-size: 17px;
  &.active {
    color: white;
  }
`;

const FooterContainer = styled.div.attrs({
  className: "d-flex flex-column",
})`
  @media (min-width: @screen-lg-min) {
    flex-direction: row;
  }
`;

const FooterLeftContainer = styled.div`
  @media (min-width: @screen-lg-min) {
    padding: 50px 0 40px 80px;
    width: 35%;
  }
`;

const FooterMiddleContainer = styled.div.attrs({
  className: "d-flex justify-content-center",
})`
  @media (min-width: @screen-lg-min) {
    padding: 50px 0 40px 0px;
    border-left: 1px solid #515151;
    border-right: 1px solid #515151;
    width: 28%;
  }
`;

const FooterRightContainer = styled.div`
  @media (min-width: @screen-lg-min) {
    padding: 50px 40px 40px 0;
    width: 37%;
  }
`;

const FooterIcon = styled.img`
  width: 30px;
  height: 30px;
`;

const ActionIcon = styled.div`
  padding: 7px;
  border-radius: 5px;
  cursor: pointer;

  > svg {
  }

  &:hover {
    background: #ddd;
    outline: 1px solid #ccc;
  }

  &.disabled {
    cursor: not-allowed;
    color: #999;

    &:hover {
      background: none;
      outline: none;
    }
  }
`;

const ScrollBar = styled.div.attrs({
  className: "overflow-auto",
})`
  &::-webkit-scrollbar {
    display: block;
    width: ${(props) => props.width || "3px"};
    height: ${(props) => props.height || "3px"};
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.color || "#b3b1b1"};
    border-radius: 30px;
  }

  &::-webkit-scrollbar-track {
    background-color: ${(props) => props.backgroundColor || "white"};
  }
`;

const CloseIcon = styled.i.attrs({
  className:
    "fa-solid fa-close d-flex justify-content-center align-items-center",
})`
  height: ${(props) => props.height || "12px"};
  width: ${(props) => props.width || "12px"};
`;

export {
  Icon,
  Input,
  Nav,
  Navbar,
  NavItemContainer,
  Notification,
  CoreContainer,
  FullViewContainer,
  CustomizationSpinnerContainer,
  LandingPageContainer,
  HeroSectionContainer,
  HeroSection,
  Logo,
  HeadingContainer,
  Heading,
  TextContainer,
  Text,
  SubText,
  Overlay,
  HeroBtnContainer,
  HeroButton,
  BenefitHead,
  BenefitProjectContainer,
  BenefitCard,
  CardHead,
  Video,
  FooterSection,
  FooterFormSection,
  FooterFormContainer,
  FormHeaderContainer,
  FormHeader,
  LandingPageForm,
  LandingPageFormGroup,
  LandingPageInput,
  FormButton,
  FooterInfoSection,
  FooterInfo,
  ProductName,
  SearchBar,
  CLPImage,
  CLPLabel,
  CLPButton,
  InfoContainer,
  CircledLabel,
  DimensionInput,
  ExtensionInput,
  Header,
  NavbarBrand,
  NavbarBrandImg,
  RegisterButton,
  HeroSectionHeading1,
  HeroSectionHeading2,
  WhiteBtn,
  HeroSectionVideo,
  Section,
  BusinessEasySectionHeading1,
  BusinessEasySectionHeading2,
  Frame,
  FrameText,
  AISectionImage,
  KnowMoreButton,
  Tag,
  TechBox,
  TableContainer,
  TableRow,
  Column,
  ReadMoreButton,
  FeatureImg,
  FaqToggleContainer,
  FaqToggleRow,
  FaqToggleHeader,
  PlusIcon,
  FaqToggleBody,
  FooterContainer,
  FooterLeftContainer,
  FooterMiddleContainer,
  FooterRightContainer,
  FooterIcon,
  ActionIcon,
  ScrollBar,
  CloseIcon,
};
